export default "__VITE_ASSET__4Ox4iEdJ__"